import ButtonBase from '@material-ui/core/ButtonBase'
import { makeStyles } from '@material-ui/core/styles'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'

import AppLogo from '../ui/app-logo'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  collapseButton: {
    position: 'absolute',
    top: '50%',
    right: -theme.spacing(3),
    transform: 'translateY(-50%)',
    width: 28,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    borderRadius: '999px 0 0 999px',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    boxShadow: '0 6px 16px rgba(15,23,42,0.14)',
    opacity: 0,
    pointerEvents: 'none',
    transition:
      'opacity 200ms ease, transform 200ms ease, color 200ms ease, background-color 200ms ease, box-shadow 200ms ease',
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.hover,
      boxShadow: '0 10px 22px rgba(15,23,42,0.18)',
      transform: 'translateY(-50%) scale(1.08)',
    },
    '.max-sidebar-panel:hover &': {
      opacity: 1,
      pointerEvents: 'auto',
    },
    '.max-sidebar-panel:hover &:not(:hover) $collapseIcon': {
      animation: '$collapseNudge 1.8s ease-in-out infinite',
    },
    '.max-sidebar-panel:hover &:not(:hover) $collapseGhost': {
      animation: '$collapseGhost 1.8s ease-in-out infinite',
    },
    '&:hover $collapseIcon, &:hover $collapseGhost': {
      animation: 'none',
    },
  },
  collapseIcon: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  collapseGhost: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    opacity: 0,
    pointerEvents: 'none',
  },
  '@keyframes collapseNudge': {
    '0%, 100%': {
      transform: 'translateX(0)',
    },
    '55%': {
      transform: 'translateX(-0.5px)',
    },
    '75%': {
      transform: 'translateX(-2px)',
    },
  },
  '@keyframes collapseGhost': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-2px)',
    },
    '15%': {
      opacity: 0.45,
      transform: 'translateX(-4px)',
    },
    '70%': {
      opacity: 0.18,
      transform: 'translateX(-9px)',
    },
    '100%': {
      opacity: 0,
      transform: 'translateX(-12px)',
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.spacing(0.25),
  },
  '@media (prefers-reduced-motion: reduce)': {
    collapseButton: {
      '.max-sidebar-panel:hover &:not(:hover) $collapseIcon': {
        animation: 'none',
      },
      '.max-sidebar-panel:hover &:not(:hover) $collapseGhost': {
        animation: 'none',
      },
    },
  },
}))

type SidebarHeaderProps = {
  onCollapseSidebar: () => void
}

const SidebarHeader = ({ onCollapseSidebar }: SidebarHeaderProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ButtonBase
        className={classes.collapseButton}
        onClick={onCollapseSidebar}
        aria-label="Collapse sidebar"
        title="Collapse sidebar"
      >
        <span className={classes.collapseIcon}>
          <ChevronLeftIcon fontSize="small" />
        </span>
        <span className={classes.collapseGhost} aria-hidden="true">
          <ChevronLeftIcon fontSize="small" />
        </span>
      </ButtonBase>
      <div className={classes.logo}>
        <AppLogo />
      </div>
    </div>
  )
}

export default SidebarHeader
